import React, { useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useLocation } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";

import { captureOrderRequest } from "../Purchase/store/actions";
import { useStyles } from "./styles";

export const PayPalReturn = (props) => {
  const { captureOrder } = props;
  const classes = useStyles();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");

    if (token) {
      captureOrder(token);
    } else {
      // No token, redirect to failed page
      window.location.href = "/pilot/payment/failed";
    }
  }, [location.search, captureOrder]);

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <CircularProgress size={60} />
        <div className={classes.loadingText}>
          Processing your payment...
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  isCapturingOrder: state.purchase?.isCapturingOrder || false,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      captureOrder: captureOrderRequest,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PayPalReturn);
